<template>
  <div class="drawer-search-list">
    <ul
      v-if="projects.length !== 0"
      :class="[fold ? 'project-list-fold' : '', 'project-list']"
    >
      <li
        v-for="item in showProjects"
        :key="item._id"
        :class="[project._id !== item._id?'active':'','serchlist-item drawer_list_item']"
        @click="chooseProject(item._id)"
      >
        <div style="overflow:hidden">
          <div class="projectname" :class="[project._id !== item._id ? 'projectactive' : '']">
            <span>{{`${item.部门?`${item.部门}-`:''}${item.项目名称}`}}</span>
          </div>
          <div class="search-tag-box">
            <span v-if="item.客户公司" class="">{{item.客户公司}}</span>
            <span v-if="item.项目状态" class="">{{item.项目状态}}</span>
            <span v-if="item.保密" class="">保密</span>
            <span v-if="item.独家" class="">独家</span>
            <span v-if="item.替换" class="">替换</span>
            <span v-if="item.新建" class="">新建</span>
            <span v-if="item.紧急重要" class="">紧急重要</span>
            <span v-if="item.刚需必成" class="">刚需必成</span>
          </div>
        </div>
      </li>
    </ul>
    <h4 v-else>没有搜索到项目</h4>
    <span v-if="showProjects.length === 1">
      <span v-if="showDuijie(showProjects[0])" style="margin-right:20px;">项目对接:{{showDuijie(showProjects[0])}}</span>
      <span v-if="showProjects[0].客户联系人 && showProjects[0].客户联系人[0]" @click="showRadish({ rid: showProjects[0].客户联系人[0]._id })">对接HR:{{showProjects[0].客户联系人[0].姓名}}</span>
    </span>

    <div v-if="projects.length > 1">
      <i v-if="fold" class="el-icon-arrow-down fold-btn" @click="modifyFold"></i>
      <i v-else class="el-icon-arrow-up fold-btn" @click="modifyFold"></i>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    projects: { type: Array, default: () => [] },
    project: { type: Object, default: () => ({}) },
    fold: { type: Boolean, default: false },
  },
  data() {
    return {
      showProjects: [],
    }
  },
  watch: {
    fold(newValue, oldValue) {
      this.setShowProjects()
    },
    projects(newValue, oldValue) {
      this.setShowProjects()
    },
  },
  mounted() {
    this.setShowProjects()
  },
  methods: {
    showDuijie(project){
      const arr = project.项目对接 || []
      return arr.filter(v=>v).join('、')
    },
    showRadish(row) {
      if (!row.rid || row.状态 === '失效') return
      window.open(`${window.frontend}/#/radish-detail-blank/${row.rid}`, '_blank')
    },
    dateFormat(val, format = 'yyyy-mm-dd') {
      return dateFormat(val, format)
    },
    setShowProjects() {
      const id = this.project._id
      if (this.fold) {
        this.showProjects = id ? this.projects.filter(val => val._id === id) : this.projects
      } else {
        const index = this.projects.findIndex(val => val._id === id)
        if (index !== -1) {
          const temp = this.projects[0]
          this.projects[0] = this.projects[index]
          this.projects[index] = temp
        }
        this.showProjects = this.projects
      }
    },
    modifyFold() {
      this.$emit('modifyFold')
    },
    chooseProject(id) {
      this.$emit('chooseProject', { id })
    },
  },
}
</script>
<style scoped>
.drawer-search-list {
  padding-bottom: 4px;
}
.project-list {
  max-height: 190px;
  overflow: auto;
  padding: 0;
  list-style: none;
}
.project-list-fold {
}
.serchlist-item {
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
  padding: 4px 10px;
  color: #171717;
  border-radius: 8px;
}
/* .serchlist-item.active{
  background-color: #2478b5;
} */
/* .serchlist-item.active .search-tag-box{
  color: #ececec;
} */
.serchlist-item:last-child {
  border: none;
}
.serchlist-item:hover{
  background-color: #8fbbd033;
  border-radius: 4px;
}
.projectactive {
  color: #5aa2ea;
}
.projectname {
  font-size: 12px;
  line-height: 22px;
}
.search-tag-box {
  padding-top: 5px;
  padding-left:4px;
  color:#bfbfbf;
  /* padding: 5px 0; */
}
.search-tag {
  margin-right: 21px;
  margin-bottom: 5px;
  padding: 4px 9px;
  color: #fff;
  display: inline-block;
  background: #fe8973;
  border-radius: 2px;
  opacity: 0.76;
}
.search-tag.success {
  background-color: #fe8973;
}
.search-tag.primary {
  background-color: #ab70ea;
}
.search-tag.warning {
  background-color: #8290f3;
}
.fold-btn {
  width: 100%;
  line-height: 20px;
  margin: 5px 0;
  color: #19b1e0;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
.search-tag-box span::after{
  content: '|';
  margin: 0 4px;
  display: inline-block;
}
.search-tag-box span:last-child::after{
  content: '|';
  display: none;
}
</style>
